import { initializeApp } from 'firebase/app';
import { getDatabase, ref } from 'firebase/database';
import { getAnalytics, logEvent } from 'firebase/analytics';

if (
  !process.env['VITE_FIREBASE_API_KEY'] ||
  !process.env['VITE_FIREBASE_AUTH_DOMAIN'] ||
  !process.env['VITE_FIREBASE_DATABASE_URL'] ||
  !process.env['VITE_FIREBASE_PROJECT_ID'] ||
  !process.env['VITE_FIREBASE_STORAGE_BUCKET'] ||
  !process.env['VITE_FIREBASE__MESSAGING_SENDER_ID'] ||
  !process.env['VITE_FIREBASE_APP_ID'] ||
  !process.env['VITE_FIREBASE_MEASUREMENT_ID']
) {
  throw new Error('Missing Firebase configuration values');
}

const firebaseConfig = {
  apiKey: process.env['VITE_FIREBASE_API_KEY'],
  authDomain: process.env['VITE_FIREBASE_AUTH_DOMAIN'],
  databaseURL: process.env['VITE_FIREBASE_DATABASE_URL'],
  projectId: process.env['VITE_FIREBASE_PROJECT_ID'],
  storageBucket: process.env['VITE_FIREBASE_STORAGE_BUCKET'],
  messagingSenderId: process.env['VITE_FIREBASE__MESSAGING_SENDER_ID'],
  appId: process.env['VITE_FIREBASE_APP_ID'],
  measurementId: process.env['VITE_FIREBASE_MEASUREMENT_ID'],
} as const;

const firebaseApp = initializeApp(firebaseConfig);

export const db = getDatabase(firebaseApp);
export const analytics = getAnalytics(firebaseApp);
export const roomsRef = ref(db, 'rooms');

export const logPageView = (
  pageName: string,
  additionalParams?: Record<string, string>,
) => {
  logEvent(analytics, 'page_view', {
    page_name: pageName,
    ...additionalParams,
  });
};
export const getParticipantsRefByRoomId = (roomId: string) =>
  `rooms/${roomId}/participants`;

export const roomsPath = '/rooms';
export const getRoomsPathById = (uid: string) => `rooms/${uid}`;
